import IComponent from "components/commons/IComponent";
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils.js";
import * as query from "@arcgis/core/rest/query.js";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import Circle from "@arcgis/core/geometry/Circle.js";
import "./QuickView.scoped.css";
import geometryTools from "utils/geometryTools";

let isInitialized = false;
const QUICK_VIEW_LIST = [
  {
    name: "Off",
  },
  {
    name: "Man-made Feature",
    layer: "Overlay/QuickView/MapServer/0",
    minScale: 20000,
    mapPopup: function(mGraphic) {
      var mContent = "";
      mContent +=
        "<span style='font-weight: bold;'>Feature No.</span> : " +
        mGraphic.attributes["SLOPE_NO"] +
        "<br />";
      mContent +=
        "<span style='font-weight: bold;'>Location</span> : " +
        mGraphic.attributes["LOCATION"] +
        "<br />";
      var mSMR_CAT_CD = mGraphic.attributes["SMR_CAT_CD"];
      if (mSMR_CAT_CD.indexOf("MIX") >= 0) {
        mContent +=
          "<span style='font-weight: bold;'>Maintenance Agent</span> : Mixed (" +
          mGraphic.attributes["MAINT_AGEN"] +
          ")<br />";
      } else {
        mContent +=
          "<span style='font-weight: bold;'>Maintenance Agent</span> : " +
          mGraphic.attributes["MAINT_AGEN"] +
          "<br />";
      }
      mContent +=
        "<span style='font-weight: bold;'>District Council</span> : " +
        mGraphic.attributes["DISTRICT"];
      return mContent;
    },
  },
  {
    name: "DH Order",
    layer: "Overlay/QuickView/MapServer/1",
    minScale: 10000,
    mapPopup: function(mGraphic) {
      var mContent = "";
      mContent +=
        "<span style='font-weight: bold;'>DH Order</span> : " +
        mGraphic.attributes["DH_ORDER"];
      return mContent;
    },
  },
  {
    name: "LandLot",
    layer: "GInfo/iC1000_ginfo/MapServer",
    popupTitles: [
      "Lot",
      "GLA",
      "MICA",
      "LicenceAndPermitPoly",
      "TenancyPoly",
      "LAOPropertyManagement",
      "Waiver",
      "DepositAreaAndVestingOrder",
    ],
    layerIds: [10, 6, 11, 9, 14, 7, 15, 5],
    attributes: [
      (mGraphic) => {
        var mContent = "";
        var mCISLOTDISPLAYNAME = mGraphic.attributes["CISLOTDISPLAYNAME"];
        var mLOTCODE = mGraphic.attributes["LOTCODE"];
        var mCodedValueDomain = QUICK_VIEW_LIST[3].layer[0].getFieldDomain(
          "LOTCODE"
        );
        var mLOTCODE_Name = mCodedValueDomain.getName(mLOTCODE);
        if (!isNaN(mCISLOTDISPLAYNAME.substr(0, 1))) {
          mContent = mLOTCODE_Name + " " + mCISLOTDISPLAYNAME;
          mContent = mContent.replace("LOT", "Lot");
          mContent = mContent.replace("DEMARCATION DISTRICT", "DD");
          mContent = mContent.replace("TUNG CHUNG", "TC");
          mContent = mContent.replace("LAMMA ISLAND", "LM");
          mContent = mContent.replace("LANTAU", "L");
          mContent = mContent.replace(" CHEUNG CHAU", "CC");
          mContent = mContent.replace("MUI WO", "MW");
          mContent = mContent.replace(" PENG CHAU", "PC");
        } else {
          mContent = mCISLOTDISPLAYNAME.replace(" ", " Lot ");
        }
        return mContent;
      },
      "CISLOTDISPLAYNAME",
      "CISLOTDISPLAYNAME",
      "LICENCEANDPERMITNUMBER",
      "TENANCYNUMBER",
      "PMNUMBER",
      "WAIVERNUMBER",
      "SERIALORSITENUMBER",
    ],
    minScale: 5000,
    mapPopup: (g, idx) => {
      let popupContent = QUICK_VIEW_LIST[3].attributes[idx];
      if (typeof popupContent === "function") return popupContent(g);
      else return g.attributes[popupContent];
    },
  },
  {
    name: "GI Location",
    layer: "Overlay/QuickView/MapServer/2",
    minScale: 5000,
    mapPopup: function(mGraphic) {
      var mContent = "";
      mContent +=
        "Report No. : " +
        mGraphic.attributes["GISADMIN.borehole.REPNO"] +
        "<br />";
      mContent +=
        "Station No. : " +
        mGraphic.attributes["GISADMIN.borehole.STATNO"] +
        "<br />";
      mContent +=
        "Station Type : " +
        mGraphic.attributes["GISADMIN.borehole.STATTYPE"] +
        "<br />";
      return mContent;
    },
  },
];
class ClassName extends IComponent {
  quickViewData = null;
  lastMouseMove = 0;
  lastResult = undefined;
  constructor(props) {
    super(props);
    this.state = {
      activeMode: 0,
    };
    if (!isInitialized) {
      let addLayer = async (srvName) => {
        let layer = new geometryTools.FeatureLayer({
          url: `${this.$config.serverUrl}/rest/services/${srvName}`,
        });
        await layer.load();
        return layer;
      };
      QUICK_VIEW_LIST.forEach(async (info) => {
        if (info.name === "Off") return;
        if (info.layerIds)
          info.layer = await Promise.all(
            info.layerIds.map(async (i) => addLayer(info.layer + "/" + i))
          );
        else info.layer = await addLayer(info.layer);
        console.debug(info);
      });
      isInitialized = true;
    }
  }
  componentDidMount() {
    console.debug("Quick View did mount");
    this.registerEvent();
  }
  registerEvent() {
    let lastTimer = 0;
    let lastTimer2 = 0;
    reactiveUtils.watch(
      () => this.props.mapView.stationary,
      (stationary) => {
        if (stationary) {
          clearTimeout(lastTimer);
          lastTimer = setTimeout(() => this.queryForLut(), 250);
        }
      }
    );
    this.props.mapView.on("pointer-move", [], (evt) => {
      clearTimeout(lastTimer2);
      lastTimer2 = setTimeout(() => this.searchForTarget(evt), 250);
    });
  }
  componentWillUnmount() {}
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.mapView !== this.props.mapView) {
      this.registerEvent();
    }
    if (prevProps.activeMode !== this.state.activeMode) {
      this.quickViewData = undefined;
      this.lastResult = undefined;
      this.queryForLut();
    }
  }
  async queryForLut() {
    let { activeMode } = this.state;
    let mapView = this.props.mapView;
    if (activeMode === 0) return;
    let qvInfo = QUICK_VIEW_LIST[activeMode];
    if (mapView.scale > qvInfo.minScale) return;
    let queryPara = {
      geometry: this.props.mapView.extent,
      spatialRelationship: "intersects",
      outFields: ["*"],
      returnGeometry: true,
    };
    if (qvInfo.name === "LandLot") {
      let results = await Promise.all(
        qvInfo.layer.map((i) => i.queryFeatures(queryPara))
      );
      console.debug(results);
      this.quickViewData = results.map((i) => i.features);
      return;
    }
    let result = await qvInfo.layer.queryFeatures(queryPara);
    this.quickViewData = result.features;
    console.debug(result);
  }
  searchForTarget(evt) {
    if (!this.quickViewData) return;
    if (this.state.activeMode === 0) return;
    // if (Date.now() - this.lastMouseMove < 250) return;
    let activeMode = QUICK_VIEW_LIST[this.state.activeMode];
    // this.lastMouseMove = Date.now();
    let point = this.props.mapView.toMap(evt);
    let target = undefined;
    let layerIdx = undefined;
    if (activeMode.name === "GI Location") {
      let circle = new Circle({
        center: point,
        radius: 10,
        radiusUnit: "meters",
      });
      let intersected = this.quickViewData.filter((i) =>
        circle.contains(i.geometry)
      );
      if (intersected.length === 0) return;
      intersected = intersected.map((i, j) => {
        let c = Math.sqrt(
          Math.pow(Math.abs(i.geometry.x - point.x), 2) +
            Math.pow(Math.abs(i.geometry.y - point.y), 2)
        );
        return [c, i];
      });
      intersected.sort((a, b) => a[0] - b[0]);
      console.debug(intersected);
      target = intersected[0][1];
    } else if (activeMode.name === "LandLot") {
      this.quickViewData.some((l, j) =>
        l.some(
          (i) => i.geometry?.contains(point) && ((target = i), (layerIdx = j))
        )
      );
    } else
      this.quickViewData.some(
        (i) => i.geometry?.contains(point) && (target = i)
      );
    if (!target) {
      return (this.props.mapView.popup.visible = false);
    }
    if (
      target &&
      (target !== this.lastResult || !this.props.mapView.popup.visible)
    ) {
      this.lastResult = target;
      let content = document.createElement("DIV");
      content.className = "SubPanelContent AutoSize";
      let title = activeMode.popupTitles?.[layerIdx] || activeMode.name;
      Object.keys(target.attributes).forEach(
        (i) => (target.attributes[i.toUpperCase()] = target.attributes[i])
      );
      content.innerHTML = activeMode.mapPopup(target, layerIdx);
      let location = target.geometry.extent?.center || target.geometry;
      this.props.mapView.popup.open({
        title,
        content,
        location,
      });
    }
    console.debug(target);
  }
  render() {
    return (
      <div className="esri-component QuickViewContainer">
        <ToggleButtonGroup
          value={this.state.activeMode}
          exclusive
          onChange={(evt, value) =>
            value !== null && this.setState({ activeMode: value })
          }
          aria-label="text alignment"
          size="small"
          classes={{ root: "QuickViewButton" }}
        >
          {QUICK_VIEW_LIST.map((i, j) => (
            <ToggleButton key={`${i.name}-${j}`} value={j} aria-label={i.name}>
              {i.name}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </div>
    );
  }
}

export default ClassName;
